import { FC } from 'react'

import { ErrorRouteComponent } from '@tanstack/react-router'

import { Typography } from '@forto-dev/phoenix-ui-core'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back'
import { createErrorFallback } from '@/fragments/create-error-fallback'
import { Footer } from '@/fragments/footer.tsx'
import { Header } from '@/fragments/header.tsx'
import { WidgetSkeleton } from '@/fragments/widgetSkeleton'
import { useLocalisation } from '@/utils/localisation'

import { RequiredActionsMainSkeleton } from './requiredActionsSkeleton'

export const RequiredActionsLayout: FC = () => {
  const { translate } = useLocalisation()
  return (
    <Layout
      header={<Header />}
      navigation={<Back to="/" />}
      sidebar={<WidgetSkeleton count={2} />}
      main={<RequiredActionsMainSkeleton />}
      title={<Typography variant="h4">{translate('navigation.actions')}</Typography>}
      footer={<Footer />}
    />
  )
}
export const RequiredActionsErrorComponent: ErrorRouteComponent = ({ error, reset }) => {
  return (
    <Layout
      header={<Header />}
      navigation={<Back to="/" />}
      main={createErrorFallback(`An error occurred while loading Required Actions`)({ error, reset })}
      footer={<Footer />}
    />
  )
}
